import { motion } from 'framer-motion';
import styled from 'styled-components';

import { setTypography } from 'utils/styles/mixins';
import { mediaTablet } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

export const AwardsTableWrapper = styled.div`
  color: ${colors.black};

  ${mediaTablet('width: 70vw;')}
`;

export const Heading = styled.div`
  padding: 132px 16px 0;
  ${mediaTablet('padding: 40px 40px 0;')}

  h1, span {
    color: ${colors.black} !important;
  }
`;

export const Filters = styled.div`
  margin: 56px auto 110px;
  padding: 0 16px;
  ${mediaTablet('padding: 0 40px;')}

  overflow: auto;
  width: 100%;

  display: inline-flex;
  gap: 8px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export interface FilterInnerProps {
  active?: boolean;
}
export const FilterInner = styled.span<FilterInnerProps>`
  color: ${({ active }) => (active ? colors.white : colors.black)};

  ${({ theme: { locale } }) => setTypography('filter', locale)}
`;

export const TableWrapper = styled.div`
  padding: 0 16px 16px;
  ${mediaTablet('padding: 0 40px 40px;')}
`;

export const TableRow = styled(motion.div)`
  display: grid;
  grid-template-columns: 3fr 2fr 2fr;
  grid-gap: 16px;

  border-bottom: 1px solid ${colors.brightGray};
`;

export const TableHeadText = styled.span`
  padding: 16px 0;

  color: ${colors.lighterMineShaft};

  ${({ theme: { locale } }) => setTypography('small', locale)}
`;

export const TableText = styled.span`
  padding: 20px 0;

  align-self: center;

  color: ${colors.lighterMineShaft};

  ${({ theme: { locale } }) => setTypography('smallBody', locale)}
`;
